export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const EMAIL_REGEX_RFC_5322 = /^([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])$/;
export const EARLIEST_OPENING_HOUR = 7;
export const LATEST_CLOSING_HOUR = 22;
export const CVC_FAX_NUMBER = '7058801211';
